<template>
  <div>
    <a-modal v-model="visible" title="Add grade group to class" :destroyOnClose="true">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" html-type="submit" type="primary" :loading="loading" @click="handleSubmit">Assign</a-button>
      </template>
      <a-spin :spinning="loading">
        <a-form class="mb-2" :form="form" @submit="handleSubmit">
          <div class="row">
            <div class="col-md-6">
              <a-form-item label="Class">
                <a-spin :spinning="classLoading">
                  <a-select
                    placeholder="Select Class"
                    v-decorator="[
                      `class_id`,
                      {rules: [{ required: false, message: 'Please select a class' }], initialValue: undefined},
                    ]"
                  >
                    <template v-for="schoolClass in schoolClasses">
                      <a-select-option :value="schoolClass.id" :key="schoolClass.id">
                        <span class="text-bold">{{schoolClass.name}}</span>
                      </a-select-option>
                    </template>
                  </a-select>
                </a-spin>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Grade Group">
                <a-spin :spinning="gradesLoading">
                  <a-select
                    placeholder="Select Grade Group"
                    v-decorator="[
                      `grade_group_id`,
                      {rules: [{ required: false, message: 'Please select a grade group' }], initialValue: undefined},
                    ]"
                  >
                    <template v-for="gradeGroup in gradeGroups">
                      <a-select-option :value="gradeGroup.id" :key="gradeGroup.id">
                        <span class="text-bold">{{gradeGroup.name}}</span>
                      </a-select-option>
                    </template>
                  </a-select>
                </a-spin>
              </a-form-item>
            </div>
          </div>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>

export default {
  name: 'AssignClassExamGrade',
  data: function() {
    return {
      form: this.$form.createForm(this),
      schoolClasses: [],
      gradeGroups: [],
      classGradeData: null,
      gradesLoading: false,
      classLoading: false,
      loading: false,
      visible: false,
    }
  },
  mounted: function () {
    this.$eventBus.$on('openGradeAssignFormModal', this.showModal)
  },
  methods: {
    showModal(classGradeId) {
      this.visible = true
      this.getSchoolClasses()
      this.getGradeGroups()

      if (classGradeId) {
        this.getClassGradeGroup(classGradeId)
      }
    },
    handleSubmit(e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the OK button to assign grade group to class!`,
            onOk: () => {
              this.$http
                .post('/api/assign_grade_class', {
                  class_id: values.class_id,
                  grade_group_id: values.grade_group_id,
                })
                .then(({ data }) => {
                  this.$emit('created')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Successfully assigned!',
                    description: `Grade group successfully assigned to class!`,
                  })
                  this.form.resetFields()
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
    getSchoolClasses() {
      this.classLoading = true
      this.$http.get('/api/class')
        .then(({ data }) => {
          this.classLoading = false
          this.schoolClasses = data.data
        })
        .catch(error => {
          this.classLoading = false
          console.log(error)
        })
    },
    getGradeGroups() {
      this.gradesLoading = true
      this.$http.get('/api/gradegroup')
        .then(({ data }) => {
          this.gradesLoading = false
          this.gradeGroups = data.data
        })
        .catch(error => {
          this.gradesLoading = false
          console.log(error)
        })
    },
    getClassGradeGroup(classGradeId) {
      this.loading = true
      this.$http.get('/api/assign_grade_class/' + classGradeId)
        .then(({ data }) => {
          this.loading = false
          this.classGradeData = data.data

          this.$nextTick(() => {
            this.form.setFieldsValue({
              class_id: this.classGradeData.school_class_id,
              grade_group_id: this.classGradeData.grade_group_id,
            })
          })
        })
        .catch(error => {
          this.loading = false
          console.log(error)
        })
    },
    handleCancel(e) {
      this.form.resetFields()
      this.visible = false
    },
  },
}
</script>
